import { render } from "./Routes.vue?vue&type=template&id=178ed5ce&scoped=true"
import script from "./Routes.vue?vue&type=script&lang=js"
export * from "./Routes.vue?vue&type=script&lang=js"

import "./Routes.vue?vue&type=style&index=0&id=178ed5ce&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178ed5ce"]])

export default __exports__